<template>
  <div class="list bgc3" style="width:100%">
    <Header :title="$t('m.PlanMeeting')"></Header>
    <div class="spebgc" :class="login=='mobile'?'nav':'nav_wechat'">
      <table>
        <tr @click="attendinit()" class="bdc">
          <router-link class="normal color bdc" tag="td" to="/attendmeeting">{{$t('m.NewMeeting')}}</router-link>
          <router-link class="normal color bdc" tag="td" to="/personalmode">{{$t('m.PersonTemplate')}}</router-link>
          <router-link class="normal bdc bgc active" tag="td" to="/nowmeeting">{{$t('m.RecentHistoryConference')}}</router-link>
        </tr>
      </table>
    </div>
    <div class="content spebgc" style="margin-top: 0.6rem;">
      <div class="item" v-if="dmaMode">
        <span class="item_label">{{$t('m.MeetingProfile')}}</span>
        <span class="item_content">
          <Select :disabled="meetingpre.vmr_id.length==0" v-model="Meetingvalue" class="meetingtype" id="meetingChooseType" style="width:200px">
            <Option
              v-for="(item,index) in Conferencetype"
              :value="item.serviceTemplateId"
              :key="index"
            >{{item.name}}</Option>
          </Select>
        </span>
      </div>
      <div class="item">
        <span class="item_label">{{$t('m.HistoryMeetingShort')}}</span>
        <Select
          @on-change="insertmessage"
          :placeholder="$t('m.SelectHistoryMeeting')"
          style="width:200px"
          v-model="template"
          id="meetingChooseModal"
        >
          <Option
            :key="index"
            :value="item.id"
            v-for="(item,index) in templatelist"
          >{{item.meeting_name}}</Option>
        </Select>
      </div>
      <div class="item" v-show="meeting.meeting_type==2">
        <span class="item_label">{{$t('m.MeetingDate')}}</span>
        <span style="width:38%">
          <!-- <input
            class="date"
            id="data3"
            onfocus="this.blur()"
            placeholder="选择日期"
            readonly="readonly"
            type="text"
            v-model="datavalue"
          />-->
          <DatePicker
            id="datePickerId"
            v-model="datavalue"
            type="date"
            :placeholder="$t('m.SelectDate')"
            :options="optionsDisabled"
            format="yyyy-MM-dd"
            @on-change="datavalue=$event"
            @click.native="activeDate=true"
          ></DatePicker>
        </span>
        <span style="width:38%;">
          <!-- <input
            class="date"
            id="timedate3"
            onfocus="this.blur()"
            placeholder="会议时间"
            readonly="readonly"
            type="text"
            v-model="timevalue"
          />-->
          <TimePicker
            id="timePickerId"
            v-model="timevalue"
            format="HH:mm"
            :placeholder="$t('m.MeetingTime')"
            @click.native="activeDate=true"
          ></TimePicker>
        </span>
      </div>
      <div class="item" v-show="meeting.meeting_type==1">
        <span class="item_label">{{$t('m.MeetingDate')}}</span>
        <span class="item_content">{{meeting.meeting_date}}</span>
      </div>
      <div class="item">
        <span class="item_label">{{$t('m.MeetingDuration')}}</span>
        <span style="width:40%">
          <!-- <input
            class="date"
            id="time3"
            onfocus="this.blur()"
            placeholder="请选择会议日期"
            readonly="readonly"
            type="text"
            v-model="meeting_longi"
          />-->
          <TimePicker
            id="timePickerLong"
            v-model="meeting_longi"
            format="HH:mm"
            :placeholder="$t('m.MeetingDuration')"
            @click.native="activeDate=true"
          ></TimePicker>
        </span>
      </div>
    </div>
    <div class="content spebgc">
      <div class="item">
        <span class="item_label">{{$t('m.ConferenceNo')}}</span>
        <span class="item_content">
          <input
            :disabled="meetingpre.vmr_id[0]"
            :placeholder="$t('m.PlsEnterMeetingNo')"
            style="width:100%;border:none;outline:none;height:0.45rem"
            type="text"
            v-model="meeting.meeting_code"
          />
        </span>
        <span class="item_right">
          <CheckboxGroup v-model="meetingpre.vmr_id">
            <Checkbox label="1">
              <span>{{$t('m.RandomMeetingNo')}}</span>
            </Checkbox>
          </CheckboxGroup>
        </span>
      </div>
      <div class="item">
        <span class="item_label">{{$t('m.MeetingName')}}</span>
        <span class="item_content">
          <input
            maxlength="20"
            :placeholder="$t('m.PlsEnterMeetingName')"
            style="width:100%;border:none;outline:none;height:0.45rem"
            type="text"
            v-model="meeting.meeting_name"
          />
        </span>
      </div>
      <div class="item">
        <span class="item_label">{{$t('m.MeetingPassword')}}</span>
        <span class="item_content">
          <input
            :disabled="!meetingpre.vmr_id[0]"
            :type="meetingpre.password_display[0]=='1'?'password':'number'"
            pattern="[0-9]*"
            :placeholder="$t('m.PlsEnterMeetingPassword')"
            style="width:100%;border:none;outline:none;height:0.45rem"
            v-model="meeting.meeting_password"
          />
        </span>
        <span class="item_right">
          <CheckboxGroup v-model="meetingpre.password_display">
            <Checkbox :disabled="!meetingpre.vmr_id[0]" label="1">
              <span>{{$t('m.HidePassword')}}</span>
            </Checkbox>
          </CheckboxGroup>
        </span>
      </div>
    </div>
    <div class="content spebgc">
      <div class="item">
        <RadioGroup v-model="meeting.meeting_type" @on-change="changeTypeOfMeeting">
          <Radio label="1">
            <span>{{$t('m.InstantConference')}}</span>
          </Radio>
          <Radio label="2">
            <span>{{$t('m.ReservedConference')}}</span>
          </Radio>
        </RadioGroup>
      </div>
      <div
        class="item"
        style="height:auto;padding:0.15rem 0;line-height:0.3rem;box-sizing:content-box"
      >
        <span class="item_label">{{$t('m.MeetingIntroduce')}}</span>
        <span style="width:75%">
          <Input
            :autosize="true"
            :placeholder="$t('m.PlsEnterMeetingIntroduce')"
            type="textarea"
            rows=1
            id="meetingIntroTextarea"
            v-model="meeting.meeting_content"
          />
        </span>
      </div>
    </div>
    <div class="content spebgc">
      <div
        class="item"
        style="height:auto;padding:0.1rem 0;line-height:0.3rem;box-sizing:content-box"
      >
        <span class="item_label">{{$t('m.Participants')}}</span>
        <span @click="tochoicepeople">
          <img :src="imgpath.people" style="width:0.2rem;vertical-align: middle" />
        </span>
        {{peoplechoice}}
      </div>
      <div
        class="item"
        style="height:auto;padding:0.1rem 0;line-height:0.3rem;box-sizing:content-box"
      >
        <span class="item_label">{{$t('m.ConferenceTerminal')}}</span>
        <span @click="tochoiceroom">
          <img :src="imgpath.room" style="width:0.2rem;vertical-align: middle" />
        </span>
        {{roomchoice}}
      </div>
      <div
        class="item"
        style="height:auto;padding:0.10rem 0;line-height:0.3rem;box-sizing:content-box"
      >
        <span class="item_label">{{$t('m.ConferenceHost')}}</span>
        <span @click="tochoicehost()">
          <img :src="imgpath.people" style="width:0.2rem;vertical-align: middle" />
        </span>
        {{hostchoice}}
      </div>
    </div>
    <div class="content spebgc" v-if="showRecordAndLive" style="margin-bottom: 55px;">
      <div class="item">
        <CheckboxGroup style="float:left" v-model="meetingpre.cf_record">
          <Checkbox label="1">
            <span>{{$t('m.ConferenceRecord')}}</span>
          </Checkbox>
        </CheckboxGroup>
        <CheckboxGroup style="float:left" v-model="meetingpre.cf_live">
          <Checkbox label="1">
            <span>{{$t('m.ConferenceLive')}}</span>
          </Checkbox>
        </CheckboxGroup>
      </div>
    </div>

    <div @click="sub" class="button bgc">{{meeting.meeting_type=='1'?this.$t('m.OKBtn'):this.$t('m.Appointment')}}</div>

    <div class="pop" v-if="addsure">
      <div class="templatepopexit">
        <div class="popclosex" @click="addsure=false">
          <Icon type="ios-close"></Icon>
        </div>
        <div class="title-line">
          <img class="iconimg" :src="hookUrl" />
          <span class="title_sure">{{$t('m.NewBtn')}}</span>
        </div>
        <div class="templatepoptop">
          <p>{{$t('m.Meeting')}}（{{meeting.meeting_name}}）{{meeting.meeting_type == "1" ? this.$t('m.MeetingCreated'):this.$t('m.Appointment')}} {{$t('m.Successful')}}</p>
          <p>
            {{$t('m.MeetingNo')}}{{meetingNumber ||
            ""}}
          </p>
          <p>{{$t('m.PlsAttendOnTime')}}</p>
        </div>
        <div @click="addsure=false" class="templatepopbottomexit color bdc">{{$t('m.CancelBtn')}}</div>
        <div @click="addsureSuccess" class="templatepopbottomexit bgc">{{$t('m.OKBtn')}}</div>
      </div>
    </div>
  </div>
</template>
<script>
import Header from "../header/header";
import {
  creatMeeting,
  selectConfList,
  // getMeetingTemplateInfo,
  selectConfDetail,
  beforeCreateMeeting,
  MeetingPattern
} from "../../assets/js/url";

export default {
  name: "attendmeeting",
  data() {
    return {
      Meetingvalue: "",
      Conferencetypestatus: false,
      Conferencetype: [],
      addsure: false,
      meetingNumber: "",
      hookUrl: require("@/assets/images/public/hook.png"),
      login: "mobile",
      activeDate: false,
      optionsDisabled: {
        disabledDate(date) {
          return date && date.valueOf() < Date.now() - 86400000;
        }
      },
      // type: "",
      // model: false,
      datavalue: "",
      timevalue: "",
      langvalue: "0小时30分",
      meetingpre: {
        vmr_id: ["1"],
        password_display: [],
        cf_record: [],
        cf_live: []
      },
      templatelist: [],
      template: "",
      meeting_longi: "01:00",
      meeting: {
        useruuid: window.sessionStorage.getItem("UUID"),
        meeting_name: "",
        meeting_code: "",
        meeting_password: "",
        password_display: "",
        meeting_type: "1",
        meeting_date: "",
        meeting_long: "",
        meeting_content: "",
        vmr_id: "",
        cf_party: "",
        cf_terminal: "",
        cf_host: "",
        cf_record: "",
        cf_live: ""
      },
      showRecordAndLive: false,
      dmaMode:false
    };
  },
  created() {
    this.attendinit();
  },
  activated() {
    this.login = window.sessionStorage.getItem("login");
    this.getMeetingIsShow();
    this.gethistorylist();
    this.MeetingPattern();
    // this.datachoice();
  },
  computed: {
    imgpath() {
      return this.$store.state.imagestyle[this.$store.state.cssstyle];
    },
    peoplechoice() {
      return this.$store.state.meeting.cfpartyname.replace(/,/g, "，");
    },
    hostchoice() {
      return this.$store.state.meeting.cfhostname.replace(/,/g, "，");
    },
    roomchoice() {
      return this.$store.state.meeting.cfterminalname.replace(/,/g, "，");
    }
    // hasmediasuite() {
    //   return this.$store.state.hasmediasuite;
    // }
  },
  components: {
    Header
  },
  watch: {
    $route() {
      if (
        this.$route.path == "/login" ||
        this.$route.path == "/index" ||
        this.$route.path == "/forthmeetingvmr" ||
        this.$route.path == "/attendmeetinglist" ||
        this.$route.path == "/historymeeting" ||
        this.$route.path == "/historyplaymeeting" ||
        this.$route.path == "/meetingtemplate"
      ) {
        this.attendinit();
      }
    },
    activeDate(a, b) {
      let that = this;
      that.$nextTick(function() {
        $("#datePickerId input").focus(function() {
          document.activeElement.blur();
        });
        $("#timePickerId input").focus(function() {
          document.activeElement.blur();
        });
        $("#timePickerLong input").focus(function() {
          document.activeElement.blur();
        });
      });
    }
  },
  methods: {
    getMeetingIsShow() {
      this.$http.post(beforeCreateMeeting, {}).then(res => {
        if (res.data.status == 2000) {
          let data = res.data.data;
          this.showRecordAndLive = data.showRecordAndLive;
          this.dmaMode = data.dmaMode
        }
      });
    },

    MeetingPattern() {
      this.$http
        .get(MeetingPattern, {
          params:{userID: window.sessionStorage.getItem("userID")},
        })
        .then(res => {
          this.Conferencetype = [];
          for (var i = 0; i < res.data.length; i++) {
            this.Conferencetype.push({
              serviceTemplateId: res.data[i].serviceTemplateId,
              name: res.data[i].name
            });
          }
          if (this.Conferencetype.length != 0) {
            this.Conferencetypestatus = true;
            if (window.sessionStorage.getItem("Value")) {
              this.Meetingvalue = Number(
                window.sessionStorage.getItem("Value")
              );
            } else {
              this.Meetingvalue = this.Conferencetype[0].serviceTemplateId;
            }
          } else {
            this.Conferencetypestatus = false;
          }
        });
    },

    // goback() {
    //   this.$router.go(-1);
    // },
    attendinit() {
      // 记录store归零，暂时不用
      this.$store.commit("setmeetingcfparty", "");
      this.$store.commit("setmeetingcfpartyname", "");
      this.$store.commit("setmeetingcfhost", "");
      this.$store.commit("setmeetingcfhostname", "");
      this.$store.commit("setmeetingcfparty", "");
      this.$store.commit("setmeetingcfparty", "");
      this.$store.commit("setmeetingcfterminal", "");
      this.$store.commit("setmeetingcfterminalname", "");
      this.template = "";
      this.meeting = {
        useruuid: window.sessionStorage.getItem("UUID"),
        meeting_name: "",
        meeting_code: "",
        meeting_password: "",
        password_display: "",
        meeting_type: "1",
        meeting_date: "",
        meeting_long: "",
        meeting_content: "",
        vmr_id: "",
        cf_party: "",
        cf_terminal: "",
        cf_host: "",
        cf_record: "",
        cf_live: ""
      };
      this.datavalue = "";
      this.timevalue = "";
    },
    changeTypeOfMeeting() {
      this.datavalue = "";
      this.timevalue = "";
    },
    // datachoice() {
    //   const _this = this;
    //   $(function() {
    //     const currYear = new Date().getFullYear();
    //     const opt = {};
    //     opt.date = { preset: "date" };
    //     opt.datetime = { preset: "datetime" };
    //     opt.time = { preset: "time" };
    //     opt.default = {
    //       theme: "android-ics", //皮肤样式
    //       display: "modal", //显示方式
    //       mode: "scroller", //日期选择模式
    //       dateFormat: "yyyy-mm-dd",
    //       lang: "zh",
    //       showNow: true,
    //       nowText: "今天",
    //       startYear: currYear, //开始年份
    //       endYear: currYear + 10 //结束年份
    //     };
    //     const opt2 = {};
    //     opt2.date = { preset: "date" };
    //     opt2.datetime = { preset: "datetime" };
    //     opt2.time = { preset: "time" };
    //     opt2.default = {
    //       theme: "android-ics", //皮肤样式
    //       display: "modal", //显示方式
    //       mode: "scroller", //日期选择模式
    //       timeFormat: "HH小时ii分钟",
    //       lang: "zh",
    //       showNow: false,
    //       nowText: "",
    //       startYear: currYear, //开始年份
    //       endYear: currYear + 10 //结束年份
    //     };
    //     $("#data3").mobiscroll($.extend(opt["date"], opt["default"]));
    //     $("#timedate3").mobiscroll($.extend(opt["time"], opt["default"]));
    //     $("#time3").mobiscroll($.extend(opt2["time"], opt2["default"]));
    //     $("#data3").change(function() {
    //       _this.datavalue = $("#data3").val();
    //     });
    //     $("#timedate3").change(function() {
    //       _this.timevalue = $("#timedate3").val();
    //     });
    //     $("#time3").change(function() {
    //       _this.meeting_longi = $("#time3").val();
    //     });
    //   });
    // },
    tochoicepeople() {
      this.$router.push({
        path: "/userlist",
        query: {
          name: "cfparty",
          canChoose: true,
          message: this.$store.state.meeting.cfparty //要在通讯录中把人标出来
        }
      });
    },
    getnowtime() {
      const time = new Date();
      const year = time.getFullYear();
      const mouth =
        time.getMonth() + 1 < 10
          ? "0" + (time.getMonth() + 1)
          : time.getMonth() + 1;
      const day = time.getDate() < 10 ? "0" + time.getDate() : time.getDate();
      const h = time.getHours() < 10 ? "0" + time.getHours() : time.getHours();
      const m =
        time.getMinutes() < 10 ? "0" + time.getMinutes() : time.getMinutes();
      const s =
        time.getSeconds() < 10 ? "0" + time.getSeconds() : time.getSeconds();
      return year + "-" + mouth + "-" + day + " " + h + ":" + m + ":" + s;
    },
    tochoicehost() {
      this.$router.push({
        path: "/userlist",
        query: {
          name: "cfhost", //用这个字段区分
          canChoose: true,
          message: this.$store.state.meeting.cfhost //要在通讯录中把人标出来
        }
      });
    },
    tochoiceroom() {
      let dateTimeValue;
      if (this.meeting.meeting_type == 1) {
        dateTimeValue = this.getnowtime(0) + " " + "00:00:00";
      } else {
        if (this.datavalue == "")
          dateTimeValue = this.getnowtime(0) + " " + "00:00:00";
        else dateTimeValue = this.datavalue + " " + "00:00:00";
      }
      this.$router.push({
        //老版选取终端路由
        //name: "roomchoice",
        //新版选取终端路由
        name: "terminalcontrolPctest",
        query: {
          name: "cfterminal", //用这个字段区分
          message: this.$store.state.meeting.cfterminal,
          meetingType: this.meeting.meeting_type, //会议类型
          dateTimeValue: dateTimeValue //在这个时间下
        }
      });
    },
    insertmessage(e) {
      this.$http
        .post(selectConfDetail, {
          id: e
        })
        .then(res => {
          if (res.data.status === 2000) {
            let data = res.data.data;
            let temporary=Boolean(data.fixed_vmr)
            this.meeting.meeting_date = this.getnowtime();
            this.meeting.template_name = data.meeting_templatename;
            if (data.meeting_code && data.meeting_code != "undefined") {
              // this.meeting.meeting_code = data.vmr_id;
              this.meeting.meeting_code = data.fixed_vmr?res.data.vmr_id:'';
            } else {
              this.meeting.meeting_code = "";
            } // 返回的vrm_id是会议号码
            this.meeting.meeting_password =
              data.meeting_password && data.meeting_code != "undefined"
                ? data.meeting_password
                : "";
            this.meeting.meeting_name = data.meeting_name;
            this.meeting.meeting_type = data.meeting_type + "";
            this.meeting.meeting_content = data.meeting_content;
            this.meetingpre.cf_live = data.cf_live === 1 ? ["1"] : [];
            this.meetingpre.cf_record = data.cf_record === 1 ? ["1"] : [];
            this.meetingpre.vmr_id = !temporary ? ["1"] : []; // 返回的meeting_code如果为空是则为随机会议号
            this.$store.commit("setmeetingcfhost", data.cf_host);
            this.$store.commit("setmeetingcfhostname", data.cf_host_name);
            this.$store.commit("setmeetingcfparty", data.cf_party);
            this.$store.commit("setmeetingcfpartyname", data.cf_party_name);
            this.$store.commit("setmeetingcfterminal", data.cf_terminal);
            this.$store.commit(
              "setmeetingcfterminalname",
              data.cf_terminal_name
            );
          } else {
            this.$toast(res.data.data.errorDes);
          }
        });
    },
    gethistorylist() {
      const _this = this;
      this.$http
        .post(selectConfList, {
          useruuid: window.sessionStorage.getItem("UUID"),
          type: 3,
          start: 0,
          pagesize: 100
        })
        .then(res => {
          if (res.data.status == 2000) {
            this.templatelist = res.data.data;
          } else {
            this.$toast(this.$t('m.HistoryMeetingListGetFail'));
            setTimeout(function() {
              _this.$router.push("/attendmeeting");
            }, 500);
          }
        });
    },
    sub() {
      if (!this.meeting.meeting_name) {
        this.$toast(this.$t('m.MeetingNameNotNull'));
        return;
      }
      if (
        this.meeting.meeting_password &&
        this.meeting.meeting_password != "undefined"
      ) {
        const check = /[\d]{1,6}/.test(this.meeting.meeting_password);
        if (!check) {
          this.$toast(this.$t('m.MeetingPasswordFormatError'));
          return;
        }
      }
      if (this.meeting.meeting_type == 2) {
        if (this.datavalue == "" || this.timevalue == "") {
          this.$toast(this.$t('m.PlsFillDateTime'));
          return;
        }
        let bookTime = this.datavalue + " " + this.timevalue + ":00";
        let oDate1 = new Date(this.getnowtime());
        let oDate2 = new Date(bookTime);
        let diff = oDate2.getTime() - oDate1.getTime();
        let minute = parseInt(diff / 1000 / 60);
        if (minute < 0 || Math.abs(minute) < 15) {
          this.$toast(this.$t('m.AppointTimeShoudBigThanNow'));
          return;
        }
      }
      this.meeting.password_display =
        this.meetingpre.password_display[0] == "1" ? 1 : 2;
      this.meeting.vmr_id = this.meetingpre.vmr_id[0] == "1" ? 1 : 2;
      this.meeting.cf_record = this.meetingpre.cf_record[0] == "1" ? 1 : 2;
      this.meeting.cf_live = this.meetingpre.cf_live[0] == "1" ? 1 : 2;
      this.meeting.cf_party = this.$store.state.meeting.cfparty;
      this.meeting.cf_host = this.$store.state.meeting.cfhost;
      this.meeting.cf_terminal = this.$store.state.meeting.cfterminal;
      this.meeting.serviceTemplateId = this.Meetingvalue;
      if (this.meeting.meeting_type == 1) {
        this.meeting.meeting_date = this.getnowtime();
      } else {
        this.meeting.meeting_date =
          this.datavalue + " " + this.timevalue + ":00";
      }
      this.meeting.meeting_long =
        Number(parseInt(this.meeting_longi)) * 60 +
        Number(parseInt(this.meeting_longi.split(":")[1]));
      this.$loadingshow();
      this.$http.post(creatMeeting, this.meeting).then(
        res => {
          this.$loadingclose();
          if (res.data.status == 2000) {
            this.meetingNumber = res.data.data.meeting_code;
            this.addsure = true;
          } else {
            this.$toast(res.data.data.errorDes || this.$t('m.OperateFail'));
          }
        },
        err => {
          this.$loadingclose();
        }
      );
    },
    addsureSuccess() {
      this.addsure = false;
      this.sure();
    },
    sure() {
      this.model = false;
      this.meetingpre = {
        vmr_id: ["1"],
        password_display: [],
        cf_record: [],
        cf_live: []
      };
      this.meeting = {
        useruuid: window.sessionStorage.getItem("UUID"),
        meeting_name: "",
        meeting_code: "",
        meeting_password: "",
        password_display: "",
        meeting_type: "1",
        meeting_date: "",
        meeting_long: "",
        meeting_content: "",
        vmr_id: "",
        cf_party: "",
        cf_terminal: "",
        cf_host: "",
        cf_record: "",
        cf_live: ""
      };
      this.attendinit();
      this.$router.push("/index");
    }
  }
};
</script>
<style scoped>
.list {
  overflow: hidden;
  background: #eee;
  padding-bottom: 0.55rem;
}

input {
  background: transparent;
}

input:disabled {
  background: transparent;
  font-size: 0.14rem;
}

input:disabled:-moz-placeholder {
  color: #ddd;
  font-size: 0.14rem;
}

input:disabled:-ms-input-placeholder {
  color: #ddd;
  font-size: 0.14rem;
}

input:disabled::-webkit-input-placeholder {
  color: #ddd;
  font-size: 0.14rem;
}

input::-webkit-input-placeholder {
  font-size: 0.14rem;
}

td.normal {
  border-top: none;
  border-bottom: none;
  border-left: none;
}

td.normal.active {
  color: #fff;
}

.content {
  padding: 0 0.15rem;
  background-color: #fff;
  margin-top: 0.1rem;
}

.radio {
  width: 0.15rem;
  height: 0.15rem;
  display: inline-block;
  border-radius: 100%;
  vertical-align: middle;
}

i {
  font-size: 0.25rem;
  vertical-align: middle;
}

.button {
  /* width: 3.15rem;
  height: 0.44rem;
  border-radius: 3px;
  margin: 0.2rem auto;
  box-sizing: border-box;
  padding: 0 0.15rem;
  text-align: center;
  line-height: 0.44rem;
  font-size: 0.16rem;
  color: #fff; */
  width: 100%;
  height: 0.44rem;
  color: #fff;
  text-align: center;
  line-height: 0.44rem;
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 99;
  font-size:0.16rem
}

/* .modelwrap {
  width: 100%;
  height: 100%;
  top: 0.44rem;
  left: 0px;
  position: fixed;
  background: rgba(0, 0, 0, 0.4);
  z-index: 999;
}

.model {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -0.54rem;
  margin-left: -1.35rem;
  width: 2.7rem;
  height: 1.08rem;
  background-color: #fff;
  border-radius: 12px;
  box-sizing: border-box;
  padding: 0.2rem 0.06rem;
}

.modeltitle {
  text-align: center;
  height: 0.34rem;
  line-height: 0.34rem;
  font-size: 0.17rem;
  color: #000;
}

.modelact {
  text-align: center;
  height: 0.34rem;
  line-height: 0.34rem;
  font-size: 0.17rem;
  color: #000;
}

.date {
  width: 100%;
  border: 1px solid #ccc;
  outline: none;
  height: 0.3rem;
  line-height: 0.3rem;
  vertical-align: middle;
  border-radius: 3px;
  background-color: #fff;
  background: url("../../assets/images/public/down.png") no-repeat 1.1rem center;
  background-size: 0.15rem 0.1rem;
  text-align: center;
} */
</style>




// WEBPACK FOOTER //
// src/components/content/nowmeeting.vue